import {HomeItemRenderer} from "./home-item-renderer"

export class FacebookRenderer extends HomeItemRenderer{

	constructor(container:HTMLElement, isForMobile:boolean){
		super(container);
		this.isForMobile = isForMobile;
	}

	public render(){
		var entryHtml = document.createElement("div");
		entryHtml.className = "p_home_facebook"
		// The data reporter blocks the fb-script and renders a message and a button to allow the fb-widget inside <div id='indexFacebookEntryActivate'></div>.
		// When the fb-script is loaded, it hides all elements inside class="fb-xfbml-parse-ignore" and displays the fb-widget instead.
        entryHtml.innerHTML = `
        <div class='_titleSmall _type'>SCHAUSPIELHAUS AUF FACEBOOK</div>
        <div class="fb-page" data-href="https://www.facebook.com/SchauspielhausGraz" data-tabs="timeline" data-width="1000" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false">
        <blockquote cite="https://www.facebook.com/SchauspielhausGraz" class="fb-xfbml-parse-ignore">
        <a href="https://www.facebook.com/SchauspielhausGraz">Schauspielhaus Graz</a>
        <div id='indexFacebookEntryActivate'></div>
        </blockquote>
        </div>`;

		this.renderContainer(this.isForMobile).appendChild(entryHtml);
	}
}